import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';
import { FranchiseFeatureType } from '../franchises/type';

const GamesAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  featureRestriction: FranchiseFeatureType.GAME,
  routes: [
    {
      path: routesUrl.gamesHistory,
      component: React.lazy(() => import('./pages/GamesHistoryPage')),
    },
    {
      path: routesUrl.gamesCreation,
      component: React.lazy(() => import('./pages/GamesCreationPage')),
    },
    {
      path: routesUrl.gamesDetail,
      component: React.lazy(() => import('./pages/GamesDetailPage')),
    },
  ],
};

export default GamesAppConfig;
